__turbopack_context__.v({
  "className": "stem_c7d78549-module__ETIeDq__className",
});
